import React, { FC } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';

interface LoaderProps {
  size?: number;
  color?: 'black' | 'white';
  loading?: boolean;
  className?: string;
}

const COLOR_CLASSES: Record<'black' | 'white', string> = {
  black: 'ldsRingBlack',
  white: 'ldsRingWhite',
};

const Loader: FC<LoaderProps> = ({ size = 20, color = 'black', loading = false, className }) => {
  if (!loading) return null;

  const colorClass = COLOR_CLASSES[color];
  return (
    <div
      className={classNames(styles.ldsRing, colorClass, className)}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <div style={{ width: `${size}px`, height: `${size}px` }} />
      <div style={{ width: `${size}px`, height: `${size}px` }} />
      <div style={{ width: `${size}px`, height: `${size}px` }} />
      <div style={{ width: `${size}px`, height: `${size}px` }} />
    </div>
  );
};

export default Loader;
